import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import axios from "axios";
import { API } from "@/config";
import { formatRupees } from "../../utils/currency";
import { DollarSign, Calendar, UserCheck } from "lucide-react";

export default function ClinicDashboardTab({ clinicId, token }) {
    const [dashboardStats, setDashboardStats] = useState(null);

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const response = await axios.get(`${API}/clinics/${clinicId}/dashboard`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setDashboardStats(response.data);
            } catch (error) {
                console.error(error);
            }
        };
        fetchDashboard();
    }, [clinicId, token]);

    if (!dashboardStats) {
        return <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>Loading stats...</div>;
    }

    return (
        <div>
            <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
                <div className="stat-card">
                    <div className="stat-card-header">
                        <h3>Total Earnings</h3>
                        <div className="stat-icon" style={{ background: '#d1fae5' }}>
                            <DollarSign size={24} color="#065f46" />
                        </div>
                    </div>
                    <div className="stat-value">{formatRupees(dashboardStats.total_earnings)}</div>
                    <div className="stat-label">{dashboardStats.completed_appointments} completed</div>
                </div>

                <div className="stat-card">
                    <div className="stat-card-header">
                        <h3>Appointments</h3>
                        <div className="stat-icon" style={{ background: '#fef3c7' }}>
                            <Calendar size={24} color="#92400e" />
                        </div>
                    </div>
                    <div className="stat-value">{dashboardStats.total_appointments}</div>
                    <div className="stat-label">{dashboardStats.today_appointments} today</div>
                </div>

                <div className="stat-card">
                    <div className="stat-card-header">
                        <h3>Patients</h3>
                        <div className="stat-icon" style={{ background: '#dbeafe' }}>
                            <UserCheck size={24} color="#1e40af" />
                        </div>
                    </div>
                    <div className="stat-value">{dashboardStats.unique_patients}</div>
                    <div className="stat-label">{dashboardStats.staff_count} staff members</div>
                </div>
            </div>

            {/* Doctor breakdown */}
            <div className="card">
                <h2 style={{ marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600' }}>Doctor Performance</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {dashboardStats.doctor_breakdown?.map(doc => (
                        <div key={doc.doctor_id} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '0.75rem', background: '#f8fafc', borderRadius: '8px'
                        }}>
                            <div style={{ fontWeight: '600' }}>{doc.doctor_name}</div>
                            <div style={{ display: 'flex', gap: '1.5rem', color: '#64748b', fontSize: '0.875rem' }}>
                                <span>{doc.total_appointments} appts</span>
                                <span style={{ color: '#10b981', fontWeight: '600' }}>{formatRupees(doc.earnings)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

ClinicDashboardTab.propTypes = {
    clinicId: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
};
